// Environment Configuration
// Change this value to switch between environments: 'development', 'staging', 'production'
export const CURRENT_ENVIRONMENT = 'production'

// You can also set this via environment variable: REACT_APP_ENV
// The environment variable takes precedence over the constant above
export const getCurrentEnvironment = () => {
  return process.env.REACT_APP_ENV || CURRENT_ENVIRONMENT
}

// Environment-specific configurations
export const ENV_CONFIG = {
  development: {
    name: 'Development',
    apiBaseUrl: 'http://localhost:8000',
    debug: true,
  },
  staging: {
    name: 'Staging',
    apiBaseUrl: 'https://staging-aibackend.inflatein.com',
    debug: true,
  },
  production: {
    name: 'Production',
    apiBaseUrl: 'https://aibackend.inflatein.com',
    debug: false,
  },
}

// Get current environment config
export const getCurrentEnvConfig = () => {
  const env = getCurrentEnvironment()
  return ENV_CONFIG[env] || ENV_CONFIG.development
}

// Helper to check if we're in development
export const isDevelopment = () => getCurrentEnvironment() === 'development'

// Helper to check if we're in production
export const isProduction = () => getCurrentEnvironment() === 'production'

// Helper to check if we're in staging
export const isStaging = () => getCurrentEnvironment() === 'staging'

// Google Client ID
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "794401076159-arrg0qgnnfajei593lhqm2ht9gja923k.apps.googleusercontent.com"